import React from "react";
import "./App.css";
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustLayer from './components/TrustLayer';
import Solutions from './components/Solutions';
import Industries from './components/Industries';
import Technologies from './components/Technologies';
import CaseStudies from './components/CaseStudies';
import RegionalPresence from './components/RegionalPresence';
import ContactForm from './components/ContactForm';
import Blog from './components/Blog';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <TrustLayer />
        <Solutions />
        <Industries />
        <Technologies />
        <CaseStudies />
        <RegionalPresence />
        <ContactForm />
        <Blog />
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
